export interface IGWidgetProps {
    classNames?:Record<string,boolean>
}

export type TGWidgetClass = Record<string,boolean>|undefined|null
export default class GClassHelpers {
    static join(left:TGWidgetClass, right:TGWidgetClass) {
        const l = {...this.toClass(left)}, r = this.toClass(right)
        for(const k in r){
            if (r[k]) l[k] = true
        }
        return l
    }

    static toClass(classes:TGWidgetClass) : Record<string,boolean> {
        return classes ? classes : {}
    }

    static toString(classes:TGWidgetClass) : string {
        if (!classes) return ""
        else return Object.entries(classes).filter(([key,val]) => val).map(([key,val]) => key).join(" ")
    }
}